var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-iar-modal",on:{"click":_vm.onClickWrap}},[_c('div',{staticClass:"plv-iar-modal__main plv-iar-modal__main--mobile",style:({
      'width': _vm.mainWidth,
      'height': _vm.mainHeight
    }),on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default"),_vm._v(" "),(_vm.showClose)?_c('div',{staticClass:"plv-iar-modal__close",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }